export default "__VITE_ASSET__d0e4c7f2__"